/**
 * SocialProofBadge -- "X friends saved this" inline badge.
 *
 * Uses secondary (harvest gold) color to tie into the social/circles branding.
 * Only renders when count > 0.
 */

import { Users } from 'lucide-react';

interface SocialProofBadgeProps {
  count: number;
  className?: string;
}

export function SocialProofBadge({ count, className = '' }: SocialProofBadgeProps) {
  if (count <= 0) return null;

  return (
    <span className={`inline-flex items-center gap-1 text-xs font-medium text-secondary ${className}`}>
      <Users className="h-3 w-3" />
      {count} friend{count !== 1 ? 's' : ''} saved this
    </span>
  );
}
